import React from 'react'

interface PageHeaderProps {
  /** Page title (the page's only `h1`). Omit to render `children` as free-form header content. */
  title?: React.ReactNode
  /** Page-level actions (Add …, navigation shortcuts), right-aligned. */
  actions?: React.ReactNode
  /** With `title`: the search slot between title and actions. Without: free-form content. */
  children?: React.ReactNode
}

/**
 * Page header card: title, search, page actions. Wide: one row with actions
 * pushed right. Narrow: title row, then search full width, then actions.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, actions, children }) => {
  return (
    <div className="rounded-xl border border-border bg-surface p-2 shadow-sm @container">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
        {title !== undefined ? (
          <>
            <h1 className="flex min-w-0 items-center gap-2 text-2xl font-bold text-primary">
              {title}
            </h1>
            {children && (
              <div className="flex w-full min-w-0 items-center gap-2 @2xl:w-auto @2xl:max-w-md @2xl:flex-1">
                {children}
              </div>
            )}
          </>
        ) : (
          children
        )}
        {actions && (
          <div
            className="flex flex-wrap items-center gap-2 @2xl:ml-auto"
            data-testid="page-header-actions"
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  )
}
